"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import FormCheckboxInput from "./webflow_modules/Form/components/FormCheckboxInput";
import FormCheckboxWrapper from "./webflow_modules/Form/components/FormCheckboxWrapper";
import FormInlineLabel from "./webflow_modules/Form/components/FormInlineLabel";
import ListItem from "./webflow_modules/Basic/components/ListItem";

export function AdvSearchAmenitiesCheckboxItem({
  checkboxProps = {},
  showDisabled = false,
  text = "Checkbox",
}) {
  return (
    <ListItem className={"amenities-list-item"}>
      <FormCheckboxWrapper className={"checkbox-field"}>
        <FormCheckboxInput
          checked={false}
          className={"amenity-check"}
          customClassName={"w-checkbox-input--inputType-custom"}
          data-name={"amenity-label"}
          form={{
            type: "checkbox-input",
            name: "amenity-label",
          }}
          id={"amenity-label"}
          inputType={"custom"}
          name={"amenity-label"}
          required={false}
          type={"checkbox"}
          {...checkboxProps}
        />
        <FormInlineLabel className={"checkbox-label"}>{text}</FormInlineLabel>
        {showDisabled ? (
          <Block className={"show-disabled-checkbox"} tag={"div"} />
        ) : null}
      </FormCheckboxWrapper>
    </ListItem>
  );
}
